import { Modal } from 'framework/ui/ui-builder';
import { FormFieldsData, useFormContext, CreateForm } from 'framework/form';
import { EmployeesInput } from 'domain/shared/employee';
import TimeslotDurationDropdown from './TimeslotDurationDropdown';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

const Form = ({ closeModal, isAdditional = false }: { closeModal: () => void; isAdditional?: boolean }) => {
  const { submitForm = () => {}, isSubmitEnabled, isLoadingArtifact } = useFormContext();

  return (
    <>
      <EmployeesInput label="Interviewers" source="interviewers" enableAvailabilitySkillsFilter withContractors />

      {isAdditional && <TimeslotDurationDropdown source="timeslotDuration" />}

      <Box display="flex" gap={1.25}>
        <Button
          data-testid="submit-button"
          type="submit"
          onClick={submitForm}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Copy link
        </Button>
        <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={closeModal}>
          Cancel
        </Button>
      </Box>
    </>
  );
};

const MESSAGE_CONTEXT = 'InterviewerLinkForm';

const InterviewerLinkForm = ({
  closeModal,
  modalOpen,
  copyAction,
  getLink,
  isAdditional = false,
}: {
  closeModal: () => void;
  modalOpen: boolean;
  copyAction: (str: string) => void;
  getLink: (values: FormFieldsData) => Promise<object | void>;
  isAdditional?: boolean;
}) => {
  return (
    <Modal isOpen={modalOpen} hasCancelButton={false} onToggle={closeModal}>
      <CreateForm
        initialData={{ isAdditional }}
        submitFormFunc={getLink}
        afterSubmit={{
          execute: response => {
            copyAction(response);
            closeModal();
          },
        }}
        messageContext={MESSAGE_CONTEXT}
        getValidationSchemaFunc={() =>
          Promise.resolve({
            interviewers: {
              type: 'array',
              required: true,
              forEach: {
                type: 'object',
                properties: {
                  value: {
                    type: 'string',
                    required: true,
                  },
                },
              },
            },
            timeslotDuration: {
              required: {
                value: true,
                when: {
                  $isAdditional: {
                    eq: true,
                  },
                },
                message: 'Please select timeslot duration.',
              },
            },
          })
        }
      >
        <Form closeModal={closeModal} isAdditional={isAdditional} />
      </CreateForm>
    </Modal>
  );
};

export default InterviewerLinkForm;
